// extracted by mini-css-extract-plugin
export default {"root":"BlockBlogSection_root__XoOcD","media":"BlockBlogSection_media__5lPY4","image":"BlockBlogSection_image__BBd0m","text":"BlockBlogSection_text__mTUGE"};